import { render, staticRenderFns } from "./staReg.vue?vue&type=template&id=de322518&scoped=true"
import script from "./staReg.vue?vue&type=script&lang=js"
export * from "./staReg.vue?vue&type=script&lang=js"
import style0 from "./staReg.vue?vue&type=style&index=0&id=de322518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de322518",
  null
  
)

export default component.exports